"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
const common_buoy_tooltip_1 = __importDefault(require("@buoyhealth/common.buoy-tooltip"));
const StyledInputLabel = (0, styled_components_1.default)(InputLabel_1.default) `
  ${({ theme }) => theme.typography.variants.primary.small};
  color: ${({ theme }) => theme.palette.gray[100]};
  margin-bottom: 8px;
  display: flex;
`;
const StyledTooltip = (0, styled_components_1.default)(common_buoy_tooltip_1.default) `
  margin-left: 4px;
`;
/**
 * A generic input label.
 * Extends [MUI's InputLabel component](https://v4.mui.com/api/input-label/).
 * */
const InputLabel = ({ label, optional, tooltip, ...rest }) => ((0, jsx_runtime_1.jsxs)(StyledInputLabel, { ...rest, children: [label, optional ? " (optional)" : "", tooltip && (0, jsx_runtime_1.jsx)(StyledTooltip, { title: tooltip })] }));
exports.default = InputLabel;
//# sourceMappingURL=index.js.map